import { useAxiosModule } from '@/modules/_shared/axios'
import { Package } from './types'

const {
    getFromApi,
    postToApi,
    putToApi,
    patchToApi,
    deleteInApi
} = useAxiosModule()

/* Get Packages List */

export type GetPackagesListResponse = Package[]
export const getPackagesList = async () => {
    const getPackagesListUrl = 'packages/'
    const response = await getFromApi<GetPackagesListResponse>(getPackagesListUrl)
    const packagesSortedByName = response.sort((a, b) => {
        return a.name > b.name ? 1 : -1
    })
    return packagesSortedByName
}

/* Get Package */

export type GetPackageResponse = Package
export const getPackage = (code: string) => {
    const getPackageUrl = `packages/code/${code}`
    return getFromApi<GetPackageResponse>(getPackageUrl)
}

/* Get Package by id */
export const getPackageById = (id: string) => {
    const getPackageUrl = `packages/${id}`
    return getFromApi<GetPackageResponse>(getPackageUrl)
}

/* Add Package */

export type AddPackageRequest = Omit<Package, 'id'>
export const addSinglePackage = async (req: AddPackageRequest) => {
    const addPackageUrl = 'packages/create'
    await postToApi<null>(addPackageUrl, req)
}

/* Update Package */

export type UpdatePackageRequest = Package
export const updateSinglePackage = async (id: string, req: UpdatePackageRequest) => {
    const updatePackageUrl = `packages/${id}/update`
    await putToApi<null>(updatePackageUrl, req)
}

/* Activate package */

export const activateSinglePackage = async (id: string) =>
    await patchToApi<null>(`packages/${id}/activate`, null)

/* Deactivate package */

export const deactivateSinglePackage = async (id: string) =>
    await patchToApi<null>(`packages/${id}/deactivate`, null)

/* Delete package */

export const deleteSinglePackage = async (id: string) =>
    await deleteInApi<null>(`packages/${id}`)
